import { useFieldHelper, BaseFieldLayoutType, FieldLayoutProps, FieldProps } from '../../field';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useUiTheme } from 'framework/uiTheme';
import { Box } from '@mui/material';

interface FieldListLayoutProps extends FieldLayoutProps<object[]> {
  children: React.ReactElement;
  source?: string;
  isVisible?: boolean;
  isRowDirection?: boolean;
  hasSeparator?: boolean;
  [p: string]: any;
}

const FieldListLayout = ({ children, isRowDirection, hasSeparator = false, ...props }: FieldListLayoutProps) => {
  const { getValue } = useFieldHelper(props as FieldProps<object[]>);
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const arr = getValue() || [];

  const content = arr.map((val, index) => (
    <Box
      key={uuidv4()}
      className="field__item-wrapper"
      sx={hasSeparator ? { borderBottom: '1px solid', borderColor: 'border.separator', mb: 3 } : undefined}
    >
      {React.cloneElement(children, { value: val, label: '' })}
    </Box>
  ));

  const value = !!content.length && content;

  return (
    <BaseFieldLayout
      {...props}
      value={isRowDirection && arr.length ? <div className="row-list-field">{value}</div> : value}
    />
  );
};

export default FieldListLayout;
